import openRoutes from "./openRoutes";
import protectedRoutes from "./protectedRoutes";

export { openRoutes, protectedRoutes };
